import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { ReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import di from "./di/servicelocator";
import { emailRegex } from "../../../utils/regex";
import { useSelector } from "react-redux";
import "../../../stylesheets/components/Reports/TAXReports/TaxDownloadPopupMob.scss";
import { enterMail, validMail } from "@domains/utils/commonText";
import { getQueryParameterName } from "../../../utils/urlHelper";
import { storeEmailListInSessionStorage } from "@domains/utils/sessionMethods";
import { isLoginSourceEMT, LoginSource, } from "@domains/utils/emtReportCallback";
import CalendarPopupMob from "@frameworks/web/components/generic/Calendar/CalendarPopupMob";
import { getDateInFormat, getFinancialYear, previousDay, } from "@domains/utils/reportDates";
import SelectDropdown from "@frameworks/web/components/generic/selectdropdown";
import holdingDI from "@frameworks/web/components/Reports/HoldingReports/di/servicelocator";
import { getLoginSourceURL } from "@frameworks/web/utils/Navigate";
import PANPassword from "../RebrandedReports/GenericComponents/PANPassword";
import TaxDownloadStatusMob from "./TaxDownloadStatusMob";
import { WebConfigContext } from "@frameworks/web/utils/webConfig";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
const TaxDownloadPopupMob = (props) => {
    var _a, _b;
    const webConfig = useContext(WebConfigContext);
    const { loginOrigin } = useParams();
    const sales_native_app = JSON.parse(localStorage.getItem("sales_native_app"));
    const financialYear = getFinancialYear(new Date());
    let accCode = getQueryParameterName("family");
    let isTaxharvesting = getQueryParameterName("isTaxharvesting");
    const URLfromDate = getQueryParameterName("fromDate");
    const URLtoDate = getQueryParameterName("toDate");
    const urlParts = getQueryParameterName("urlParts");
    const usetaxDPURL = getQueryParameterName("usetaxDPURL") === "true";
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = location.state;
    const [startDate, setStartDate] = useState(new Date(URLfromDate));
    const [endDate, setEndDate] = useState(new Date(URLtoDate));
    const [finYear, setFinYear] = React.useState(getFinancialYear(new Date()));
    const [nextFinYear, setNextFinYear] = React.useState(finYear + 1);
    const sessionEmailList = sessionStorage.getItem("emailList");
    const inputRef = useRef(null);
    const [openCalendar, setOpenCalendar] = React.useState(false);
    const [emailList, setEmailList] = useState([]);
    const [downloadCheck, setDownloadCheck] = useState(false);
    const [emailCheck, setEmailCheck] = useState(false);
    const [PDF_or_Excel, setPDForExcel] = useState(ReportType.EXCEL);
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [currEmailvalue, setCurrEmailValue] = useState();
    const emailStatus = useSelector((state) => { var _a; return (_a = state.taxReport) === null || _a === void 0 ? void 0 : _a.emailStatus; });
    const downloadStatus = useSelector((state) => { var _a; return (_a = state.taxReport) === null || _a === void 0 ? void 0 : _a.downloadStatus; });
    const defaultEmailId = useSelector((state) => state.accountDetailsReducer.emaildId);
    const dpIds = useSelector((state) => state.holdingReport.dpTransactionEntity.dpIds);
    const isImpersonated = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.isImpersonated; });
    const lgnSrc = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const isClientLogin = loginOrigin !== LoginSource.SALES &&
        !sales_native_app &&
        !isImpersonated &&
        lgnSrc !== ELoginSource.NESTTRADER;
    const EmailListUpdate = () => {
        if (emailRegex.test(currEmailvalue) &&
            !emailList.includes(currEmailvalue)) {
            setEmailList([...emailList, currEmailvalue]);
            setCurrEmailValue("");
            storeEmailListInSessionStorage(currEmailvalue, sessionEmailList, true);
            return [...emailList, currEmailvalue];
        }
        return [];
    };
    const openDrawerLoader = React.useCallback(() => props.setShowLoader(true), []);
    const openDrawerDownloadS = React.useCallback(() => props.setDownloadSuccess(true), []);
    const openDrawerFail = React.useCallback(() => props.setDownloadFail(true), []);
    const closeDrawerLoader = React.useCallback(() => props.setShowLoader(false), []);
    const closeDrawerDownloadS = React.useCallback(() => props.setDownloadSuccess(false), []);
    const closeDrawerFail = React.useCallback(() => props.setDownloadFail(false), []);
    const [selectedDpId, setSelectedDpId] = useState(null);
    let handleSubmit = (e) => {
        e.preventDefault();
        if (!isLoginSourceEMT(lgnSrc))
            openDrawerLoader();
        let emailFormat, downloadFormat = undefined;
        accCode = window.atob(accCode);
        if (downloadCheck && isTaxharvesting) {
            downloadFormat = {
                accodes: props === null || props === void 0 ? void 0 : props.accodes,
                reportType: ReportType.PDF,
                reportName: ReportName.TAX_HARVESTING,
                taxHarvesting: "harvesting",
                isPwdProtected: true,
            };
        }
        else if (downloadCheck) {
            downloadFormat = {
                reportType: PDF_or_Excel,
                assetType: props.assetType,
                fromDate: moment(startDate).format("yyyy-MM-DD"),
                toDate: moment(endDate).format("yyyy-MM-DD"),
            };
            if (accCode)
                downloadFormat.accodes = accCode;
            if (urlParts)
                downloadFormat.urlParts = urlParts;
            if (usetaxDPURL)
                downloadFormat.usetaxDPURL = usetaxDPURL;
            if (selectedDpId)
                downloadFormat.dpId = selectedDpId;
            if (webConfig.passwordProtectedDownloadReports)
                downloadFormat.isPwdProtected = true;
            props.setOperation("download");
        }
        if (emailCheck) {
            let list = emailList;
            if (emailList.length === 0 && currEmailvalue.length > 3) {
                list = EmailListUpdate();
            }
            emailFormat = {
                fromDate: moment(startDate).format("yyyy-MM-DD"),
                toDate: moment(endDate).format("yyyy-MM-DD"),
                reportType: PDF_or_Excel,
                assetType: props.assetType,
                emailIds: list,
            };
            if (accCode)
                emailFormat.accodes = accCode;
            if (urlParts)
                emailFormat.urlParts = urlParts;
            if (usetaxDPURL)
                emailFormat.usetaxDPURL = usetaxDPURL;
            if (selectedDpId)
                emailFormat.dpId = selectedDpId;
            if (isTaxharvesting) {
                emailFormat = {
                    emailIds: list,
                    taxHarvesting: "harvesting",
                    isPwdProtected: true,
                };
            }
            props.setOperation("email");
        }
        if (downloadCheck && emailCheck) {
            props.setOperation("email_download");
        }
        di.taxReport.downloadAndSendReportTax(emailFormat, downloadFormat);
        if (isLoginSourceEMT(lgnSrc)) {
            goBack();
        }
    };
    useEffect(() => {
        if (defaultEmailId && !emailList.includes(defaultEmailId)) {
            let defaultEmailList = [defaultEmailId];
            let sessionEmailArray = sessionEmailList && sessionEmailList.split(",").length > 0
                ? sessionEmailList.split(",")
                : [];
            let finalEmailList = defaultEmailList;
            if (sessionEmailArray && sessionEmailArray.length > 0) {
                sessionEmailArray.map((emailId) => {
                    finalEmailList.push(emailId);
                });
            }
            setEmailList(finalEmailList);
        }
        else {
            let sessionEmailArray = sessionEmailList && sessionEmailList.split(",").length > 0
                ? sessionEmailList.split(",")
                : [];
            let finalEmailList = emailList && emailList.length > 0 ? emailList : [];
            if (sessionEmailArray && sessionEmailArray.length > 0) {
                sessionEmailArray.map((emailId) => {
                    if (!emailList.includes(emailId))
                        finalEmailList.push(emailId);
                });
            }
            setEmailList(finalEmailList);
        }
    }, [defaultEmailId, emailCheck]);
    useEffect(() => {
        if (PDF_or_Excel && (emailCheck || downloadCheck)) {
            if (emailCheck && emailList.length > 0) {
                setSubmitDisabled(true);
            }
            else if (downloadCheck && emailCheck && emailList.length > 0) {
                setSubmitDisabled(true);
            }
            else if (downloadCheck && !emailCheck) {
                setSubmitDisabled(true);
            }
            else {
                setSubmitDisabled(false);
            }
        }
        else {
            setSubmitDisabled(false);
        }
    }, [emailCheck, emailList, downloadCheck, PDF_or_Excel]);
    useEffect(() => {
        if ((emailStatus.isOpen !== null || downloadStatus.isOpen !== null) &&
            props.showLoader &&
            (emailCheck || downloadCheck)) {
            closeDrawerLoader();
            if ((emailCheck && emailStatus.isOpen === true) ||
                (downloadCheck && downloadStatus.isOpen === true)) {
                openDrawerDownloadS();
            }
            else {
                openDrawerFail();
            }
        }
    }, [emailStatus.isOpen, downloadStatus.isOpen]);
    const goBack = () => {
        const destination = ".." +
            getLoginSourceURL(loginOrigin) +
            "?reportName=Tax" +
            "&fromDate=" +
            URLfromDate +
            "&toDate=" +
            URLtoDate;
        navigate(destination, { replace: true });
    };
    React.useEffect(() => {
        if (startDate) {
            setStartDate(new Date(startDate));
            setFinYear(getFinancialYear(new Date(startDate)));
        }
        else {
            if (new Date(finYear, 3, 1) > new Date()) {
                setStartDate(new Date(finYear - 1, 3, 1));
            }
            else
                setStartDate(new Date(finYear, 3, 1));
            setFinYear(getFinancialYear(new Date()));
        }
        if (endDate)
            setEndDate(new Date(endDate));
        else
            setEndDate(previousDay);
        if (!!dpIds && (locationState === null || locationState === void 0 ? void 0 : locationState.showDPIDDropDown)) {
            holdingDI.holdingReport.getDPIdList();
        }
    }, []);
    useEffect(() => {
        var _a;
        if (dpIds)
            setSelectedDpId((_a = dpIds[0]) === null || _a === void 0 ? void 0 : _a.value);
    }, [dpIds]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "customForm mobForm taxreport light-blue-theme" },
            React.createElement("form", { className: "customFormSection", onSubmit: (e) => handleSubmit(e), onKeyDown: (e) => {
                    if (e.key === "Enter") {
                        if (!currEmailvalue && submitDisabled) {
                            handleSubmit(e);
                        }
                    }
                } },
                React.createElement(Link, { to: getLoginSourceURL(loginOrigin) +
                        "?reportName=Tax" +
                        "&fromDate=" +
                        getDateInFormat(startDate, "D-MMM-YY") +
                        "&toDate=" +
                        getDateInFormat(endDate, "D-MMM-YY") },
                    React.createElement("div", { className: "d-flex align-items-center mobFormHead" },
                        React.createElement("i", { className: "edel-icon-arrow-left1" }),
                        React.createElement("h1", null, isTaxharvesting
                            ? "Download Tax Harvest Report"
                            : "Download Tax Transactions"))),
                React.createElement("div", null,
                    React.createElement("div", { className: "mobFormWrap mobFormWrap-new" },
                        !isTaxharvesting && (React.createElement("div", { className: "customFormSection_field dateWrap" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-md-12 col-lg-12" },
                                    React.createElement("div", { className: "date-labels" },
                                        React.createElement("label", { htmlFor: "date", className: "form-label" }, "Date")),
                                    React.createElement("div", { className: "input-group input-group-dp" },
                                        React.createElement("div", { className: "input-group-date-section" },
                                            React.createElement(React.Fragment, null,
                                                React.createElement("label", { htmlFor: "date", className: "form-label" },
                                                    React.createElement("div", null,
                                                        React.createElement("span", { className: "fin_year" },
                                                            "FY ",
                                                            finYear,
                                                            "-",
                                                            nextFinYear.toString().substring(2)),
                                                        React.createElement("span", null,
                                                            "\u00A0(",
                                                            moment(startDate).format("D-MMM-YY"),
                                                            "\u00A0 to",
                                                            ` ${moment(endDate).format("D-MMM-YY")}`,
                                                            ")"),
                                                        " "))),
                                            React.createElement("span", { className: "input-group-append", onClick: () => setOpenCalendar(!openCalendar) },
                                                React.createElement("i", { className: "edel-icon-calendar-report" }),
                                                React.createElement("span", null, "\u00A0Change")))))))),
                        isTaxharvesting && (React.createElement("div", { className: "customFormSection_field financial-year-block-download-report" },
                            React.createElement("label", { htmlFor: "", className: "form-label" }, "Financial Year"),
                            React.createElement("div", { className: "DMSansMedium_16_500 txt_black_one1" },
                                "FY ",
                                financialYear,
                                "-",
                                (financialYear + 1).toString().substring(2)))),
                        (locationState === null || locationState === void 0 ? void 0 : locationState.showDPIDDropDown) && (React.createElement("div", { className: "customFormSection_field dateWrap" },
                            React.createElement("label", { htmlFor: "", className: "form-label" }, "DP ID"),
                            React.createElement(SelectDropdown, { id: "selectoption", selected: true, defaultValue: selectedDpId ? selectedDpId : (_a = dpIds[0]) === null || _a === void 0 ? void 0 : _a.value, selectedValue: selectedDpId ? selectedDpId : (_b = dpIds[0]) === null || _b === void 0 ? void 0 : _b.value, options: dpIds, onChangeEvent: (event) => {
                                    setSelectedDpId(event.target.value);
                                }, className: "CustomCommonDropdown ", downarrow: "edel-icon-arrow-down", dropdownOptions: dpIds, placeholderClassName: "" }))),
                        !isTaxharvesting && (React.createElement("div", { className: "customFormSection_field radioField" },
                            React.createElement("label", { htmlFor: "", className: "form-label" }, "Report Format"),
                            React.createElement("div", { className: "radio" },
                                React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "radio", name: "reportType", onChange: (e) => setPDForExcel(ReportType.PDF), required: true }),
                                    React.createElement("label", { className: "form-check-label", htmlFor: "flexRadioDefault1" }, "PDF")),
                                React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "radio", name: "reportType", 
                                        // disabled={isImpersonated && lgnSrc !== "nesttrader"}
                                        onChange: (e) => setPDForExcel(ReportType.EXCEL), checked: PDF_or_Excel !== null &&
                                            PDF_or_Excel === ReportType.EXCEL
                                            ? true
                                            : false }),
                                    React.createElement("label", { className: "form-check-label", htmlFor: "flexRadioDefault2" }, "Excel"))))),
                        React.createElement("div", { className: "mailCheckbox" },
                            React.createElement("div", { className: "customFormSection_field checkboxWrap" },
                                React.createElement("label", { htmlFor: "", className: "form-label" }, "Get Report As"),
                                React.createElement("div", { className: "checkbox" },
                                    React.createElement("div", { className: "form-check" },
                                        React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", name: "downloadType[]", id: "flexCheckDefault", disabled: (isImpersonated &&
                                                lgnSrc !== "nesttrader" &&
                                                PDF_or_Excel &&
                                                PDF_or_Excel === ReportType.EXCEL) ||
                                                sales_native_app, onChange: (e) => setDownloadCheck(e.target.checked) }),
                                        React.createElement("label", { className: "form-check-label", htmlFor: "flexCheckDefault" }, "Download")),
                                    React.createElement("div", { className: "form-check" },
                                        React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", id: "flexCheckChecked", name: "downloadType[]", onChange: (e) => {
                                                //setshowMailInput(e.target.checked);
                                                setEmailCheck(e.target.checked);
                                            } }),
                                        React.createElement("label", { className: "form-check-label", htmlFor: "flexCheckChecked" }, "Email")))),
                            emailCheck && (React.createElement("div", { className: "customFormSection_field mailWrap" },
                                React.createElement("div", { className: "blue_bg mail" },
                                    emailList.length > 0 && (React.createElement("div", { className: "mail_label" },
                                        React.createElement("ul", { className: "mail_label_body" }, emailList.map((el, idx) => {
                                            return (React.createElement("li", { key: idx, className: "mail_label_body_item" },
                                                el,
                                                !sales_native_app && (React.createElement("span", { className: "mail_label_close", onClick: () => {
                                                        setEmailList((emailList) => emailList.filter((_, i) => emailList[i] !== el));
                                                        storeEmailListInSessionStorage(el, sessionEmailList, false);
                                                    } },
                                                    React.createElement("i", { className: "edel-icon-rounded-close" })))));
                                        })))),
                                    !sales_native_app && (React.createElement("div", { className: "mail-input" },
                                        React.createElement("input", { ref: inputRef, type: "email", className: "form-control", pattern: emailRegex.source, value: currEmailvalue, disabled: isImpersonated || lgnSrc === "nesttrader", onChange: (e) => {
                                                setCurrEmailValue(e.target.value);
                                                e.target.setCustomValidity("");
                                                inputRef.current.checkValidity();
                                            }, placeholder: "Enter email address", required: emailCheck && emailList.length === 0, onInvalid: (e) => {
                                                if (e.currentTarget.validity.valueMissing) {
                                                    return e.currentTarget.setCustomValidity(enterMail);
                                                }
                                                if (e.currentTarget.validity.patternMismatch) {
                                                    return e.currentTarget.setCustomValidity(validMail);
                                                }
                                            }, onKeyDown: (e) => {
                                                if (e.key === "Enter" &&
                                                    !isImpersonated &&
                                                    lgnSrc !== "nesttrader") {
                                                    e.preventDefault();
                                                    EmailListUpdate();
                                                    if (inputRef && inputRef.current) {
                                                        inputRef.current.checkValidity();
                                                        inputRef.current.reportValidity();
                                                    }
                                                }
                                            } }),
                                        React.createElement("div", { className: `icon ${(isImpersonated || lgnSrc == "nesttrader") &&
                                                "pe-none user-select-auto"}` },
                                            React.createElement("i", { className: "edel-icon-add", onClick: () => {
                                                    if (!isImpersonated &&
                                                        lgnSrc !== "nesttrader") {
                                                        EmailListUpdate();
                                                        if (inputRef && inputRef.current) {
                                                            inputRef.current.checkValidity();
                                                            inputRef.current.reportValidity();
                                                        }
                                                    }
                                                } }))))))))),
                    !isClientLogin && (React.createElement("div", { className: "my-3" },
                        React.createElement(PANPassword, null))),
                    React.createElement("div", null,
                        React.createElement("button", { className: "btn btn-primary custom_btn", type: "submit", disabled: !submitDisabled }, "Submit")))),
            React.createElement(TaxDownloadStatusMob, { showLoader: props.showLoader, operation: props.operation, closeDrawerLoader: closeDrawerLoader, downloadSuccess: props.downloadSuccess, closeDrawerDownloadS: closeDrawerDownloadS, downloadFail: props.downloadFail, closeDrawerFail: closeDrawerFail, goBack: goBack }),
            React.createElement("div", { className: "secondary-navy-theme" },
                React.createElement(CalendarPopupMob, { openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, startDate: startDate, endDate: endDate, finYear: finYear, setStartDate: setStartDate, setEndDate: setEndDate, setFinYear: setFinYear, customTime: true, setNextFinYear: setNextFinYear })))));
};
export default TaxDownloadPopupMob;
